































































import Vue from 'vue';
import Component from 'vue-class-component';
import {UserModule} from '@/store/modules/User';
import {User} from '@/store/models';
import Loader from '@/components/loader/Loader.vue';
import router from '@/router';

@Component({
    props: ['userId'],
    components: {
        Loader
    }
})
export default class ProfileComponent extends Vue {

    private userLoaded: boolean = UserModule.loggedIn;

    get user() {
        return UserModule.user;
    }

    public created() {
        this.userLoaded = false;
        UserModule.loadUser().then(() => {
            this.userLoaded = true;
        });
    }

    /**
     * Save user data
     */
    private saveUser() {
        this.userLoaded = false;

        if (this.user) {
            UserModule.saveUser(this.user).then(() => {
                this.$router.push({name: 'survey'});
            });
        } else {
            // TODO Print error message
            // TODO Change static userId
            UserModule.loadUser().then(() => {
                this.userLoaded = true;
            });
        }
    }
}
